"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var classnames_1 = require("classnames");
var utils_1 = require("../utils");
var ResponsiveResizeComponent_1 = require("../base/ResponsiveResizeComponent");
var floatMarker_1 = require("../floatMarker");
var ButtonsGroupContext_1 = require("./ButtonsGroupContext");
var ButtonsGroup = /** @class */ (function (_super) {
    tslib_1.__extends(ButtonsGroup, _super);
    function ButtonsGroup(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onButtonClick = function (name) {
            var _a = _this.props, onChange = _a.onChange, active = _a.active;
            if (name !== active) {
                onChange(name);
            }
        };
        _this.setRef = function (el) {
            _this.$group = el;
        };
        _this.state = { markerTop: 0, markerLeft: 0, markerWidth: 0, markerHeight: 0 };
        _this.$group = null;
        return _this;
    }
    ButtonsGroup.prototype.componentDidMount = function () {
        _super.prototype.componentDidMount.call(this);
        this.markSelectedButton();
    };
    ButtonsGroup.prototype.componentDidResize = function (e) {
        this.markSelectedButton();
    };
    ButtonsGroup.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.active !== this.props.active) {
            this.markSelectedButton();
        }
    };
    ButtonsGroup.prototype.markSelectedButton = function () {
        var _this = this;
        var _a = this.props, theme = _a.theme, flat = _a.flat, active = _a.active;
        if (flat || !active) {
            return;
        }
        var activeButton = this.$group.querySelector("." + theme.active);
        if (!activeButton) {
            return;
        }
        utils_1.raf(function () {
            var offsetTop = activeButton.offsetTop;
            var offsetLeft = activeButton.offsetLeft;
            var rect = activeButton.getBoundingClientRect();
            _this.setState({
                markerTop: offsetTop,
                markerLeft: offsetLeft,
                markerWidth: rect.width,
                markerHeight: rect.height
            });
        });
    };
    ButtonsGroup.prototype.render = function () {
        var _a, _b;
        var _c = this.props, children = _c.children, className = _c.className, theme = _c.theme, onChange = _c.onChange, active = _c.active, flat = _c.flat, icons = _c.icons, disabled = _c.disabled, borders = _c.borders, dark = _c.dark, others = tslib_1.__rest(_c, ["children", "className", "theme", "onChange", "active", "flat", "icons", "disabled", "borders", "dark"]);
        var _d = this.state, top = _d.markerTop, left = _d.markerLeft, width = _d.markerWidth, height = _d.markerHeight;
        var classes = classnames_1.default(theme.group, className, (_a = {},
            _a[theme.borders] = borders,
            _a));
        var markerClasses = classnames_1.default(theme.marker, (_b = {},
            _b[theme.icons] = icons,
            _b[theme.disabled] = disabled,
            _b[theme.dark] = dark,
            _b));
        return (React.createElement(ButtonsGroupContext_1.default.Provider, { value: {
                onButtonClick: this.onButtonClick,
                activeButtonName: this.props.active,
                flat: this.props.flat,
                disabled: this.props.disabled
            } },
            React.createElement("div", { className: classes, ref: this.setRef },
                active && !flat ? (React.createElement(floatMarker_1.FloatMarker, { className: markerClasses, width: width, height: height, top: top, left: left })) : null,
                children)));
    };
    ButtonsGroup.defaultProps = {
        onChange: utils_1.noop
    };
    return ButtonsGroup;
}(ResponsiveResizeComponent_1.default));
exports.default = ButtonsGroup;
